//  ----------      START   IMPORT  BLOCK       ----------
import React from 'react';
//  Widgets
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
//  Config
import iconsChronicCategories from '../../../../../ConfigFiles/icons_chronic_categories';
//  ----------      START   IMPORT  BLOCK       ----------

const NumberImage = React.forwardRef(({ number, alt, width, height, enabled = true, onClick, tooltipText }, ref) => {
  const imagePath = iconsChronicCategories[number];

  // Define the image style based on whether it's enabled or disabled
  const imageStyle = {
    width: width,
    height: height,
    opacity: enabled ? 1 : 0.5,
    cursor: enabled && onClick ? 'pointer' : 'default',
  };

  // Handle image click
  const handleClick = () => {
    //  Only execute the onClick function if enabled and a function is provided.
    if (enabled && onClick) {
      onClick(); 
    }
  };

  return (
    <OverlayTrigger
      placement="left"
      overlay={<Tooltip>{tooltipText}</Tooltip>}
    >
      <img
        //  Apply ref to the actual DOM element (render problems).
        ref={ref}
        src={imagePath}
        alt={alt}
        style={imageStyle}
        onClick={handleClick}
      />
    </OverlayTrigger>
  );
});

export default NumberImage;
